export default "__VITE_ASSET__BYJTjQws__"